import styled from 'styled-components'
import { t } from 'ttag'
import { useContext } from 'react'

import { features } from '@h2/components/media'
import { PB40T, PG, NAVIANCEBLUE } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Heading as HeadingBase } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { WarningIcon } from '@h2/components/icons/warning'
import { ChangeIcon } from '@h2/components/icons/change'
import { NextIcon } from '@h2/components/icons/next'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { Card } from '@h2/common/components/card'
import { Globals } from '@h2/globals'

import { props } from './props'
import { OptionBody } from './components'

import { Create } from '../highlights/create'

const Heading = styled(HeadingBase)`
  display: flex;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 0;
  gap: 15px;

  > span[role='img'] svg {
    width: 65px;
    height: 65px;
  }

  @media (${features.minWidth.laptop}) {
    font-size: 30px;
    line-height: 34px;
  }
`
const Wrap = styled(Flex)`
  height: 100%;
  flex-direction: column;

  > p {
    margin: 25px 0;
    font-size: 16px;
    line-height: 20px;
    color: black;
  }

  > ul {
    flex-direction: column;
  }

  @media (${features.minWidth.laptop}) {
    > p {
      margin: 40px 0;
      font-size: 20px;
      line-height: 24px;
      color: ${PB40T};
    }

    > ul {
      flex-direction: row;
    }
  }
`
const EmailWarning = ({ inDialog, properties, validate, renderPanel }) => {
  const { isNavianceUser } = useContext(Globals)

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={isNavianceUser ? NAVIANCEBLUE : PG}>
        <Create isNamePanel type={isNavianceUser ? 'navianceUser' : 'unknown'} />
      </Card.Highlight>
      <Card.Content>
        <Wrap>
          <Heading level="2">
            <WarningIcon size="large" />
            <span>{t`We've detected you've entered a personal email address.`}</span>
          </Heading>
          <Text align="center">
            {t`We recommend using your email address associated with your school, as this enables us to optimize your experience.`}
          </Text>
          <OptionGroup
            gap="15px"
            onClick={value => {
              if (value === 'change') {
                renderPanel('email')
              } else {
                validate(properties)
              }
            }}>
            <Option value="change">
              <OptionBody>
                <ChangeIcon size="large" />
                <span className="flex">
                  <span>{t`Change email`}</span>
                  <span>{t`Change the email to your organization address to help improve your experience.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="continue">
              <OptionBody>
                <NextIcon size="large" />
                <span className="flex">
                  <span>{t`Use email entered`}</span>
                  <span>{t`Continue to register with the email address you entered.`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
        </Wrap>
      </Card.Content>
    </Card>
  )
}

EmailWarning.propTypes = { ...props }

export { EmailWarning }
